interface SkeletonProps {
  width?: number | string
  height?: number | string
  radius?: number | string
  style?: React.CSSProperties
}

export function Skeleton({ width = '100%', height = 16, radius = 4, style }: SkeletonProps) {
  return (
    <div
      className="skeleton-shimmer"
      style={{ width, height, borderRadius: radius, flexShrink: 0, ...style }}
    />
  )
}

export function PostCardSkeleton() {
  return (
    <div
      style={{
        background: 'var(--surface)',
        borderRadius: 'var(--radius-md)',
        boxShadow: 'var(--shadow-card)',
        padding: 16,
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
      }}
    >
      <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
        <Skeleton width={40} height={40} radius="50%" />
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 6 }}>
          <Skeleton width={120} height={14} />
          <Skeleton width={60} height={11} />
        </div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 7 }}>
        <Skeleton width="100%" height={13} />
        <Skeleton width="80%" height={13} />
        <Skeleton width="55%" height={13} />
      </div>
      <div style={{ display: 'flex', gap: 20 }}>
        <Skeleton width={20} height={20} radius="50%" />
        <Skeleton width={20} height={20} radius="50%" />
        <Skeleton width={20} height={20} radius="50%" />
      </div>
    </div>
  )
}

export function NotificationSkeleton() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 12,
        padding: '14px 16px',
        borderBottom: '1px solid var(--border)',
      }}
    >
      <Skeleton width={32} height={32} radius="50%" />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8 }}>
        <Skeleton width={200} height={13} />
        <Skeleton width={60} height={11} />
      </div>
    </div>
  )
}

export function ConversationSkeleton() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '12px 16px',
        borderBottom: '1px solid var(--border)',
      }}
    >
      <Skeleton width={40} height={40} radius="50%" />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8 }}>
        <Skeleton width={120} height={13} />
        <Skeleton width={180} height={12} />
      </div>
    </div>
  )
}

export function AccountCardSkeleton() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '12px 16px',
        background: 'var(--surface)',
        borderBottom: '1px solid var(--border)',
      }}
    >
      <Skeleton width={40} height={40} radius="50%" />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8 }}>
        <Skeleton width={120} height={14} />
        <Skeleton width={80} height={12} />
      </div>
      <Skeleton width={70} height={32} radius="var(--radius-pill)" />
    </div>
  )
}
